export default __webpack_public_path__ + "static/media/roadtax.471767c9.png";